// extracted by mini-css-extract-plugin
module.exports = {"heading":"TaxonomiesList_heading__9_5mp","list":"TaxonomiesList_list__7d_1H","listInner":"TaxonomiesList_listInner__XDuUM"};